import React, { useEffect, useState } from "react";
import {
  Form,
  Select,
  Input,
  DatePicker,
  Button,
  Modal,
  Descriptions,
  Tag,
  Typography,
  Space,
  Alert,
  Card,
  Checkbox,
  Switch,
  Radio,
  Table,
} from "antd";
import moment from "moment";
import { useDispatch } from "react-redux";
import { SaveOutlined, UpOutlined, DownOutlined, WhatsAppOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { toRupiah } from "../../../libs";
import { affiliateChecker, affiliateChecker2, discountChecker } from "../../../appRedux/actions";
import { baseRequest } from "../../../util/Api";
import TextArea from "antd/lib/input/TextArea";
import { getConfiguration } from "../../../appRedux/actions/Configuration";
import {
  CheckCircleOutlined,
} from '@ant-design/icons';
import { getRooms } from "../../../appRedux/actions/Booking";
import { use } from "react";
import { getTrainingBundle, getTrainingBundleParticipant } from "../../../appRedux/actions/TrainingBundles";

export default function TrainingRegistrationForm({
  trainings = [],
  trainingsLoading = false,
  trainingOptions = [],
  trainingOptionsLoading = false,
  onChangeTrainingsFilter,
  onSubmit,
  trainingRegistration,
}) {
  const [form] = Form.useForm();
  const [locations, setLocations] = useState([]);
  const [inputDiscountCode, setInputDiscountCode] = useState("");
  const [inputAffiliateCode, setInputAffiliateCode] = useState("");
  const [affiliatePercent, setAffiliatePercent] = useState(0);
  const [discountPercent, setDiscountPercent] = useState(null);
  const [discountPrice, setDiscountPrice] = useState(null);
  const [discountId, setDiscountId] = useState(null);
  const [affiliateCode, setAffiliateCode] = useState(null);
  const [isTypeChanged, setIsTypeChanged] = useState(false);
  const [isTrainingOptionIdChanged, setIsTrainingOptionIdChanged] = useState(false);
  const [showAdvancedFields, setShowAdvancedFields] = useState(false);
  const [rules, setRules] = useState("")
  const [bookingShown, setBookingShown] = useState(false)
  const [wantToBook, setWantToBook] = useState(false)
  const [rooms, setRooms] = useState([])
  const [checkInDate, setCheckInDate] = useState("")
  const [checkOutDate, setCheckOutDate] = useState("")
  const [selectedTraining, setSelectedTraining] = useState(null);
  const [selectedBundling, setSelectedBundling] = useState(null);
  const [bundlingWarning, setBundlingWarning] = useState(false);
  var dispatch = useDispatch();

  useEffect(async () => {
    const data = await baseRequest("get", "/trainings/locations", null);
    let options = [];
    data.map((value) => {
      options.push({
        value: value,
        label: value,
      });
    });
    setLocations(options);
    const config = await getConfiguration("training_rules")
    setRules(config.value)
  }, []);

  useEffect(() => {
    if (trainings.length < 1) {
      form.setFieldsValue({ training_id: null });
    } else {
      if (form.getFieldValue("training_id") !== null) {
        if (inputDiscountCode || inputAffiliateCode) {
          if (isTypeChanged || isTrainingOptionIdChanged) {
            form.setFieldsValue({ training_id: trainings[0].id });
          } else {
            form.setFieldsValue({
              training_id: form.getFieldValue("training_id"),
            });
          }
        } else {
          form.setFieldsValue({ training_id: trainings[0].id });
        }
      } else {
        form.setFieldsValue({ training_id: trainings[0].id });
      }
      setSelectedTraining(trainings[0]);
      onLocationChange()
      getAllRooms()
    }
    setSelectedBundling(null);
  }, [trainings]);

  useEffect(() => {
    getAllRooms()
  }, [wantToBook]);

  useEffect(() => {
    if (selectedTraining === null || selectedBundling === null)
      return
    const parsedSelected = parseIndoMultiMonth(selectedTraining.dates_summary);
    const parsedBundling = parseIndoMultiMonth(selectedBundling.dates_summary);
    const set2 = new Set(parsedBundling);
    const hasOverlap = parsedSelected.some(d => set2.has(d));
    setBundlingWarning(hasOverlap);
  }, [selectedBundling]);

  function parseIndoMultiMonth(str) {
    const months = {
      Januari: 0,
      Februari: 1,
      Maret: 2,
      April: 3,
      Mei: 4,
      Juni: 5,
      Juli: 6,
      Agustus: 7,
      September: 8,
      Oktober: 9,
      November: 10,
      Desember: 11,
    };

    const yearMatch = str.match(/\d{4}/);
    if (!yearMatch) return [];

    const year = parseInt(yearMatch[0]);

    // Hilangkan tahun
    const cleanStr = str.replace(yearMatch[0], "").trim();

    // Split berdasarkan koma
    const segments = cleanStr.split(",");

    const results = [];

    segments.forEach(segment => {
      const words = segment.trim().split(" ");

      if (words.length === 2) {
        // contoh: "28 Februari"
        const day = parseInt(words[0]);
        const month = months[words[1]];
        results.push(new Date(year, month, day));
      }

      if (words.length === 3) {
        // contoh: "6 7 8 Maret" (jika tanpa koma)
        const month = months[words[words.length - 1]];
        words.slice(0, -1).forEach(d => {
          results.push(new Date(year, month, parseInt(d)));
        });
      }
    });

    return results.map(d => d.toISOString().split("T")[0]);
  }

  function getAllRooms() {
    if (!wantToBook || !form.getFieldValue("training_id"))
      return
    getRooms(form.getFieldValue("training_id")).then(data => {
      setRooms(data)
      form.setFieldsValue({ room_number: null })
    })
    const training = !trainingRegistration
      ? trainings.find((t) => t.id === form.getFieldValue("training_id"))
      : trainingRegistration.training;
    const splitted = training.dates_summary.split(" ")
    const month = splitted[splitted.length - 2]
    const year = splitted[splitted.length - 1]
    const firstDate = splitted[0].replace(/\D/g, '')
    const lastDate = splitted[splitted.length - 3].replace(/\D/g, '')
    const checkIn = moment(firstDate + " " + month + " " + year, "DD MMMM YYYY").subtract(1, 'days').format("dddd, D MMMM YYYY")
    const checkOut = moment(lastDate + " " + month + " " + year, "DD MMMM YYYY").format("dddd, D MMMM YYYY")
    setCheckInDate(checkIn)
    setCheckOutDate(checkOut)
  }

  function onLocationChange() {
    // Fungsi booking sementara dihide dulu
    // if (form.getFieldValue("training_location") &&
    //   form.getFieldValue("training_location").toLowerCase() == "jakarta"
    //   && form.getFieldValue("training_type") == "offline"
    //   && form.getFieldValue("training_id") != null)
    //   setBookingShown(true)
    // else
    setBookingShown(false)
  }

  async function showBundlingOptions(bundle_ids) {
    const data = await getTrainingBundleParticipant(form.getFieldValue("training_option_id"), bundle_ids);
    const dataSource = [];
    data.map(d => {
      d.trainings.map(t => {
        dataSource.push({
          key: t.id,
          id: t.id,
          name: t.name,
          dates_summary: t.dates_summary,
          time_start: t.time_start,
          time_end: t.time_end,
          is_online: t.is_online,
          location: t.location,
          price: d.price,
          training_bundle_id: d.id,
        })
      })
    })
    const modal = Modal.confirm({
      title: "Pilih Bundling",
      centered: true,
      width: 900,
      closable: true,
      icon: <QuestionCircleOutlined />,
      content: <div>
        <Table
          dataSource={dataSource}
          columns={[
            {
              title: 'Name',
              dataIndex: 'name',
              key: 'name',
            },
            {
              title: 'Lokasi',
              dataIndex: 'location',
              key: 'location',
              render: (location, field) => (<>
                {location ? location : <>
                  {field.is_online ?
                    <span style={{ color: "green" }}>ONLINE</span>
                    :
                    <span style={{ color: "blue" }}>OFFLINE</span>}
                </>
                }
              </>),
            },
            {
              title: 'Tanggal',
              dataIndex: 'dates_summary',
              key: 'dates_summary',
            },
            {
              title: 'Waktu',
              dataIndex: 'time_start',
              key: 'time_start',
              render: (time_start, field) => <>{time_start} - {field.time_end}</>,
            },
            {
              title: 'Total Harga Paket',
              dataIndex: 'price',
              key: 'price',
              render: (price, field) => <>{toRupiah(price)}</>,
            },
            {
              title: '',
              render: (field) => <>
                <Button type="primary" onClick={() => {
                  setSelectedBundling(dataSource.find(t => t.id == field.id));
                  modal.destroy();
                }}>Pilih</Button>
              </>,
            },
          ]}
        />
      </div>,
      okButtonProps: {
        style: { display: 'none' }
      },
    })
  }

  return (
    <Form
      scrollToFirstError={true}
      form={form}
      layout="vertical"
      initialValues={{
        training_type: "offline",
        training_location: null,
        training_dates: moment(),
        paid_off: true,
        is_retraining: false,
        dp_deadline: moment(),
      }}
      onValuesChange={(changedValues, allValues) => {
        if ("training_id" in changedValues) {
          const training = trainings.find(
            (t) => t.id === changedValues.training_id
          );
          setSelectedTraining(training);
          setSelectedBundling(null);
        }
        if (
          "training_option_id" in changedValues ||
          "training_type" in changedValues ||
          "training_location" in changedValues ||
          "training_dates" in changedValues
        ) {
          if (allValues.training_option_id) {
            onChangeTrainingsFilter({
              training_option_id: allValues.training_option_id,
              is_online: allValues.training_type === "online",
              location:
                allValues.training_type === "offline"
                  ? (allValues.training_location ? allValues.training_location : "XXXXXXXXXX")
                  : null,
              start_date: allValues.training_dates
                .startOf("month")
                .toISOString(),
              end_date: allValues.training_dates.endOf("month").toISOString(),
              // status: "available",
            });
          }
          setIsTypeChanged(true);
          setIsTrainingOptionIdChanged(true);
        } else {
          setIsTypeChanged(false);
          setIsTrainingOptionIdChanged(false);
        }
      }}
      onFinish={(v) => {
        const result = {
          training_id: v.training_id,
          discount_id: discountId,
          affiliate_code: affiliateCode,
          // affiliate_point:
          //   v.affiliate_point !== undefined && v.affiliate_point !== ""
          //     ? v.affiliate_point
          //     : 0,
          is_online: v.training_type == "online",
          rules_checked: v.rules_checked,
          room_number: v.room_number,
          training_bundle_id: selectedBundling ? selectedBundling.training_bundle_id : null,
          training_bundle_training_id: selectedBundling ? selectedBundling.id : null,
        };
        const training = !trainingRegistration
          ? trainings.find((t) => t.id === result.training_id)
          : trainingRegistration.training;
        const totalPercent =
          discountPercent === 100
            ? discountPercent
            : discountPercent !== null
              ? discountPercent + affiliatePercent
              : affiliatePercent;
        const discount = (totalPercent / 100) * training.price + discountPrice;
        const totalPrice =
          discountPercent !== null ||
            discountPrice !== null ||
            affiliatePercent !== 0
            ? training.price - discount
            : training.price;
        const trainingOption = training.training_option;
        // let totalAffiliatePointUsed = result.affiliate_point * 1000;
        // if (totalAffiliatePointUsed > totalPrice) {
        //   totalAffiliatePointUsed = totalPrice;
        // }
        const discountBundling = selectedBundling ? affiliatePercent * selectedBundling.price / 100 : 0;
        Modal.confirm({
          title: "Konfirmasi",
          centered: true,
          width: 900,
          icon: null,
          content: (
            <Descriptions size="small" bordered column={1}>
              <Descriptions.Item label="Training">
                {trainingOption.name + " "}
              </Descriptions.Item>
              <Descriptions.Item label="Tipe Training">
                {result.is_online ? (
                  <Tag color="green" style={{ margin: 0 }}>
                    ONLINE
                  </Tag>
                ) : (
                  <Tag color="blue" style={{ margin: 0 }}>
                    OFFLINE
                  </Tag>
                )}
              </Descriptions.Item>
              <Descriptions.Item label="Jadwal">
                {training.dates_summary}
              </Descriptions.Item>
              {inputDiscountCode !== "" && (
                <Descriptions.Item label="Diskon">
                  {discountPercent === null && discountPrice === null ? (
                    <p style={{ margin: 0 }}>
                      Silahkan klik tombol <b>Terapkan Kode</b> terlebih dahulu
                    </p>
                  ) : discountPercent !== null ? (
                    discountPercent + "%"
                  ) : (
                    toRupiah(discountPrice)
                  )}
                </Descriptions.Item>
              )}
              {inputAffiliateCode !== "" && discountPercent !== 100 && (
                <Descriptions.Item label="Diskon Affiliate">
                  {affiliatePercent === 0 ? (
                    <p style={{ margin: 0 }}>
                      Silahkan klik tombol <b>Terapkan Kode</b> terlebih dahulu
                    </p>
                  ) : (
                    affiliatePercent + "%"
                  )}
                </Descriptions.Item>
              )}
              {/* {result.affiliate_point > 0 && (
                <Descriptions.Item label="Point Affiliasi">
                  {totalAffiliatePointUsed === totalPrice
                    ? totalPrice / 1000
                    : result.affiliate_point}
                </Descriptions.Item>
              )} */}
              {selectedBundling && <>
                <Descriptions.Item label="Bundling">
                  <Space>
                    <span>{selectedBundling.name}</span>
                    {selectedBundling.is_online ?
                      <span style={{ color: "green" }}>ONLINE</span>
                      :
                      <span style={{ color: "blue" }}>OFFLINE</span>
                    }
                    <span>{selectedBundling.location && selectedBundling.location}</span>
                    <span>{selectedBundling.dates_summary}</span>
                    <span>{selectedBundling.time_start} - {selectedBundling.time_end}</span>
                  </Space>
                  {/* {selectedTraining.training_bundles.filter(tb => tb.id == selectedBundling)[0].trainings.filter(t => t.id !== selectedTraining.id).map(t => <>
                    <Space key={t.id}>
                      {t.is_online ?
                        <span style={{ color: "green" }}>ONLINE</span>
                        :
                        <span style={{ color: "blue" }}>OFFLINE</span>
                      }
                      {t.location && t.location}
                      {t.name}
                      {t.dates_summary}
                      {t.time_start} - {t.time_end}
                    </Space>
                  </>)} */}
                </Descriptions.Item>
              </>}
              <Descriptions.Item label="Total harga">
                {selectedBundling ? <>
                  {discountBundling !== 0 ? <>
                    <Typography.Text delete style={{ display: "block" }}>
                      {toRupiah(selectedBundling.price)}
                    </Typography.Text>
                    {toRupiah(selectedBundling.price - discountBundling)}
                  </> : <>
                    {toRupiah(selectedBundling.price)}
                  </>}
                </> : <>
                  {/* toRupiah(selectedTraining.training_bundles.filter(tb => tb.id == selectedBundling)[0].price) : <> */}
                  {totalPrice !== training.price && (
                    <Typography.Text delete style={{ display: "block" }}>
                      {toRupiah(training.price)}
                    </Typography.Text>
                  )}
                  {toRupiah(totalPrice)}
                </>}
              </Descriptions.Item>
              {/* {result.affiliate_point > 0 && (
                <Descriptions.Item label="Sudah dibayar">
                  {totalAffiliatePointUsed >= 500000 &&
                    totalAffiliatePointUsed < totalPrice ? (
                    <>
                      {toRupiah(totalAffiliatePointUsed)}{" "}
                      <Tag color="success">DP Lunas</Tag>
                    </>
                  ) : totalAffiliatePointUsed === totalPrice ? (
                    <>
                      {toRupiah(totalPrice)} <Tag color="success">Lunas</Tag>
                    </>
                  ) : (
                    toRupiah(totalAffiliatePointUsed)
                  )}
                </Descriptions.Item>
              )} */}
            </Descriptions>
          ),
          onOk: () => onSubmit(result),
        });
      }}
    >
      {!trainingRegistration && (
        <>
          <Alert message="Jika ada kendala pendaftaran, silahkan hubungi admin melalui whatsapp 081908191001"
            type="info"
            showIcon
            action={
              <a href="https://wa.me/6281908191001?text=Saya%20ada%20kendala%20pendaftaran" target="_blank"
                className="ant-btn ant-btn-sm ant-btn-info"
                style={{ marginTop: "auto", marginBottom: "auto" }}>
                <WhatsAppOutlined /> Whatsapp
              </a>
            }
            closable />
          <Form.Item
            label="Pilihan training"
            name="training_option_id"
            rules={[
              { required: true, message: "Mohon pilih pilihan training" },
            ]}
          >
            <Select
              loading={trainingOptionsLoading}
              showSearch
              placeholder="pilih pilihan training"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {trainingOptions.map((t) => (
                <Select.Option key={t.id} value={t.id} label={t.name}>
                  {t.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item label="Tipe training" name="training_type" required>
            <Select>
              <Select.Option value="offline">Offline</Select.Option>
              <Select.Option value="online">Online</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item shouldUpdate noStyle>
            {
              () => (
                <Form.Item
                  label="Lokasi training"
                  name="training_location"
                  required
                  style={{
                    display:
                      form.getFieldValue("training_type") === "offline"
                        ? "block"
                        : "none",
                  }}
                >
                  <Select options={locations}>
                  </Select>
                </Form.Item>
              )
            }
          </Form.Item>
          <Form.Item label="Bulan training" name="training_dates" required>
            <DatePicker picker="month" format="MMMM YYYY" allowClear={false} />
          </Form.Item>
        </>
      )}
      {!trainingRegistration ? (<>
        <Form.Item
          label="Jadwal training"
          rules={[{ required: true, message: "mohon pilih jadwal training" }]}
          name="training_id"
        >
          {trainings.length > 0 ? (
            <Select
              placeholder="pilih jadwal training"
              loading={trainingsLoading}
              disabled={
                form.getFieldValue("training_option_id") === null ||
                form.getFieldValue("training_option_id") === undefined
              }
              onChange={getAllRooms}
            >
              {trainings.map((t) => (
                <Select.Option key={t.id} value={t.id} disabled={!t.is_running}>
                  {t.dates_summary} - {toRupiah(t.price)}
                </Select.Option>
              ))}
            </Select>
          ) : (
            <>
              {(form.getFieldValue("training_option_id") && ((form.getFieldValue("training_type") == "offline" && form.getFieldValue("training_location")) || form.getFieldValue("training_type") == "online") && form.getFieldValue("training_dates")) ? (
                <Alert message={<span>Kuota sudah penuh atau jadwal belum tersedia di bulan yg anda pilih.<br />Silahkan pilih jadwal bulan berikutnya atau hubungi admin ID-Networkers via whatsapp 0819-0819-1001</span>}
                  type="info"
                  showIcon
                  action={
                    <a href="https://wa.me/6281908191001?text=Saya%20ada%20kendala%20pendaftaran" target="_blank"
                      className="ant-btn ant-btn-sm ant-btn-info"
                      style={{ marginTop: "auto", marginBottom: "auto" }}>
                      <WhatsAppOutlined /> Whatsapp
                    </a>
                  } />
              ) : (
                <Alert message="Silahkan pilih Pilihan training, Tipe training, Lokasi training (jika offline), dan Bulan training terlebih dahulu."
                  type="info" />
              )}
            </>
          )}
        </Form.Item>
        {/* {(selectedTraining && selectedTraining.training_bundles.filter(t => t.enabled).length > 0) && ( */}
        {(selectedTraining && selectedTraining.bundles.length > 0) && (
          <Card
            size="small"
            hoverable
          >
            <Card.Meta
              title="Training Bundling"
              description="Bundle hemat: bayar lebih sedikit, belajar lebih banyak." />
            <div style={{ marginTop: "1rem" }}>
              {selectedBundling ? <>
                <Space direction="vertical">
                  <Space size="middle">
                    <span>{selectedBundling.name}</span>
                    {selectedBundling.is_online ?
                      <span style={{ color: "green" }}>ONLINE</span>
                      :
                      <span style={{ color: "blue" }}>OFFLINE</span>
                    }
                    <span>{selectedBundling.location && selectedBundling.location}</span>
                    <span>{selectedBundling.dates_summary}</span>
                    <span>{selectedBundling.time_start} - {selectedBundling.time_end}</span>
                    <span>{toRupiah(selectedBundling.price)}</span>
                    <Button
                      type="primary"
                      size="small"
                      style={{ margin: 0 }}
                      onClick={() => setSelectedBundling(null)}
                    >Batalkan</Button>
                  </Space>
                  {bundlingWarning &&
                    <Alert
                      message="Tanggal training bundling ada yang sama dengan jadwal training yang dipilih. Apakah anda yakin?"
                      type="warning"
                      showIcon
                      closable={false} />
                  }
                </Space>
              </> : <>
                <Button type="primary" onClick={() => showBundlingOptions(selectedTraining.bundles)}>Pilih Bundling</Button>
              </>}
            </div>
          </Card>
        )}
      </>) : (
        <Form.Item label="Jadwal training">
          <Input
            disabled
            value={
              trainingRegistration.training.training_option.name +
              " - " +
              (!trainingRegistration.is_online
                ? trainingRegistration.training.location
                : "Online") +
              " - " +
              trainingRegistration.training.dates_summary
            }
          />
        </Form.Item>
      )}
      {bookingShown && (
        <>
          <Form.Item
            label="Apakah anda dari luar jakarta dan ingin booking kamar penginapan? (Khusus peserta training offline Jakarta dan khusus peserta laki-laki)"
            valuePropName="checked"
            name="want_to_book">
            <Switch checkedChildren="Ya" unCheckedChildren="Tidak"
              onChange={(v) => {
                setWantToBook(v)
              }} />
          </Form.Item>
          {wantToBook && (
            <>
              <Form.Item
                label="Pilih Nomor Kasur (no.1-6 kasur bawah, no.7-12 kasur atas).
                Mohon maaf jika fasilitas seadanya"
                name="room_number"
                rules={[{ required: true, message: "Mohon pilih nomor kasur" }]}
              >
                <Radio.Group optionType="button" buttonStyle="solid" options={rooms.map((room => {
                  return {
                    label: room.number,
                    value: room.number,
                    disabled: room.booked,
                  }
                }))} onChange={(e) => {
                  form.setFieldsValue({ room_number: e.target.value })
                }} />
                <p>
                  Waktu Checkin : {checkInDate} jam 18.00 WIB<br />
                  Waktu Checkout : {checkOutDate} jam 13.00 WIB
                </p>
              </Form.Item>
            </>
          )}
        </>
      )}
      
      <Form.Item shouldUpdate noStyle>
        {() => (selectedBundling == null) && (<>
          <Form.Item>
            <a
              href={() => false}
              onClick={() => setShowAdvancedFields(!showAdvancedFields)}
            >
              {showAdvancedFields ? <UpOutlined /> : <DownOutlined />} Tampilkan
              lebih {showAdvancedFields ? "sedikit" : "banyak"}
            </a>
          </Form.Item>
          <div style={{ display: showAdvancedFields ? "block" : "none" }}>
            <Form.Item noStyle shouldUpdate>
              {() =>
                !form.getFieldValue("is_retraining") && (
                  <>
                    {/* <Form.Item
                  name="affiliate_point"
                  label="Gunakan Affiliate Point"
                >
                  <Input type="number" placeholder="Contoh: 200" />
                </Form.Item> */}
                    {!selectedBundling && (
                      <Form.Item
                        label="Kode Diskon (Pastikan klik tombol “Terapkan Kode”)"
                        name="discount_id"
                      >
                        <Space wrap>
                          <Input.Search
                            placeholder="MASUKKAN KODE"
                            enterButton={"Terapkan Kode"} // <SendOutlined />
                            style={{ width: "300px" }}
                            value={inputDiscountCode}
                            onChange={(e) => setInputDiscountCode(e.target.value)}
                            disabled={
                              form.getFieldValue("training_option_id") === null ||
                              form.getFieldValue("training_option_id") === undefined
                            }
                            onSearch={
                              inputDiscountCode !== ""
                                ? async () => {
                                  const result = await dispatch(
                                    discountChecker({
                                      code: inputDiscountCode,
                                      training_id:
                                        form.getFieldValue("training_id"),
                                    })
                                  );
                                  setDiscountPercent(result.percent);
                                  setDiscountPrice(result.price);
                                  setDiscountId(result.id);
                                }
                                : null
                            }
                          />
                          {discountPercent !== null && (
                            <Tag color="blue" style={{ margin: 0 }}>
                              Diskon {discountPercent}%
                            </Tag>
                          )}
                          {discountPrice !== null && (
                            <Tag color="blue" style={{ margin: 0 }}>
                              Diskon {toRupiah(discountPrice)}
                            </Tag>
                          )}
                        </Space>
                      </Form.Item>
                    )}
                    <Form.Item
                      label="Kode Affiliasi (Pastikan klik tombol “Terapkan Kode”)"
                      name="affiliate_code"
                    >
                      <Space wrap>
                        <Input.Search
                          placeholder="MASUKKAN KODE"
                          enterButton={"Terapkan Kode"} // <SendOutlined />
                          style={{ width: "300px" }}
                          value={inputAffiliateCode}
                          onChange={(e) => setInputAffiliateCode(e.target.value)}
                          disabled={
                            form.getFieldValue("training_option_id") === null ||
                            form.getFieldValue("training_option_id") === undefined ||
                            discountPercent === 100
                          }
                          onSearch={
                            inputAffiliateCode !== ""
                              ? async () => {
                                const result = await affiliateChecker2({
                                  code: inputAffiliateCode,
                                  training_id:
                                    form.getFieldValue("training_id"),
                                });
                                setAffiliatePercent(0);
                                setAffiliateCode('');
                                if (result) {
                                  setAffiliatePercent(5);
                                  setAffiliateCode(result.affiliate_code);
                                }
                              }
                              : null
                          }
                        />
                        {affiliatePercent !== 0 && discountPercent !== 100 && (
                          <Tag color="blue" style={{ margin: 0 }}>
                            Diskon {affiliatePercent}%
                          </Tag>
                        )}
                      </Space>
                    </Form.Item>
                    <Form.Item shouldUpdate noStyle hidden>
                      {() =>
                        form.getFieldValue("already_paid") < 500000 && (
                          <Form.Item
                            label="Batas waktu pelunasan uang muka (Rp 500.000)"
                            name="dp_deadline"
                            rules={[{ required: true, message: "Mohon diisi" }]}
                          >
                            <DatePicker
                              showTime
                              format="dddd, DD MMMM YYYY [pukul] HH:mm"
                              allowClear={false}
                            />
                          </Form.Item>
                        )
                      }
                    </Form.Item>
                  </>
                )
              }
            </Form.Item>
          </div>
        </>)}
      </Form.Item>

      <Form.Item
        rules={[{ required: true, message: "Mohon untuk menyetujui peraturan training" }]}
        name="rules_checked" valuePropName="checked" label={null}
        onChange={(e) => {
          if (e.target.checked)
            form.setFieldsValue({ rules_checked: "checked" })
          else
            form.setFieldsValue({ rules_checked: null })
        }}
      >
        <Checkbox>Saya telah menyetujui peraturan training <a href="#" onClick={() => {
          Modal.info({
            title: "Peraturan Training",
            centered: true,
            width: 600,
            closable: true,
            icon: <CheckCircleOutlined />,
            content: <div dangerouslySetInnerHTML={{ __html: rules }}></div>,
            onOk: () => { },
          })
        }}>berikut ini</a></Checkbox>
      </Form.Item>

      <center>
        <Button
          htmlType="submit"
          type="primary"
          icon={<SaveOutlined />}
          size="large"
          disabled={!form.getFieldValue('training_id')}
        >
          Daftar
        </Button>
      </center>
    </Form >
  );
}
